import { defineCopy } from '@/copy';

/** push strings. Keep the voice: short, funny, no em dashes. */
export const copy = defineCopy('push', {
  bell: 'Inbox',
  bellUnread: 'Inbox, {n} unread',
  inbox: {
    title: 'Inbox',
    today: 'Today',
    earlier: 'Earlier',
    markAll: 'Mark all read',
    loadOlder: 'Older pings',
    settings: 'Ping settings',
    unread: 'Unread',
    empty: 'Nothing yet. Enjoy the silence.',
    emptyBody: 'Run reminders, waitlist news and card drops land here.',
    errorTitle: 'The inbox fumbled.',
    errorBody: 'Could not load your pings.',
    retry: 'Try again',
    justNow: 'Just now',
    minutesAgo: '{n} min ago',
    hoursAgo: '{n} h ago',
    yesterday: 'Yesterday',
    marked: 'All caught up.',
  },
  pings: {
    title: 'Pings',
    line: 'Run reminders and waitlist news land here first.',
    on: 'Pings are on for this phone.',
    reconnectTitle: 'Pings lost the signal.',
    reconnectBody: 'This phone said yes, but the connection dropped.',
    reconnect: 'Tap to reconnect pings',
    optedOutTitle: 'Pings are off here.',
    optedOutBody: 'Your call. This phone stays quiet until you say otherwise.',
    turnOn: 'Turn pings back on',
    ask: {
      body: 'Reminders before tip off, waitlist news, your new card. Six a day at most, quiet at night.',
      action: 'Ping me',
      on: 'Pings are on. Go get open.',
      failed: 'Could not switch pings on. Try again in a sec.',
      declined: 'No pings. The inbox still works.',
    },
    denied: {
      title: 'Pings are off for TTS.',
      ios: 'Turn them on in iPhone Settings, then Notifications, then TTS Hoops.',
      android: 'Long-press the TTS icon, tap App info, then Notifications.',
      other: 'Turn them on in your browser settings for this site.',
      calendar: 'Use your calendar instead',
    },
    unsupported: {
      title: 'No pings on this phone.',
      body: 'This browser cannot do them. The inbox and your calendar still work.',
    },
    serverOff: {
      title: 'Pings are switched off.',
      body: 'The server is not sending any. The inbox still fills up.',
    },
    types: {
      title: 'What pings you',
      groups: {
        runs: 'Runs',
        court: 'On the court',
        extras: 'Extras',
      },
      'session.new': { label: 'New runs', help: 'Someone put a run on the calendar.' },
      'session.nudge': { label: 'In or out?', help: 'A nudge when you have not answered.' },
      'session.reminder_24h': { label: 'Day before', help: 'Tomorrow, 19:00, do not forget.' },
      'session.reminder_2h': { label: 'Two hours before', help: 'Lace up soon. Skips quiet hours.' },
      'session.waitlist_promoted': { label: 'Waitlist news', help: 'Somebody blinked and you are in.' },
      'session.changed': { label: 'Run moved or off', help: 'Time changes and cancellations.' },
      'session.recap': { label: 'Run recaps', help: 'Who ran the day.' },
      'game.up': { label: 'You are up', help: 'Your game is starting. Comes through quiet hours.' },
      'studio.card_ready': { label: 'Card is ready', help: 'Your portrait finished cooking.' },
      'gamelab.new_game': { label: 'New Lab games', help: 'The agent invented something.' },
      'system.test': { label: 'Test pings', help: '' },
    },
    quiet: {
      title: 'Quiet hours',
      help: 'Most pings wait until morning. Game call-ups still come through.',
      from: 'Quiet from',
      to: 'Until',
    },
    cap: {
      label: 'Pings a day',
      suffix: 'Reminders for runs you are in do not count',
    },
    test: 'Send a test ping',
    testSent: 'Sent. Check your lock screen.',
    testLimit: 'Easy. Five test pings an hour.',
    testFailed: 'Test ping did not go out.',
    off: 'Turn off on this phone',
    offDone: 'Pings are off on this phone.',
    saveFailed: 'Did not save. Try again.',
    badge: 'The icon badge counts your unread pings.',
  },
  askSheet: {
    first: {
      title: 'Want a ping before tip off?',
      body: 'Reminders, waitlist news, your new card. Max 6 a day, quiet at night.',
    },
    nudge: {
      title: 'Want a nudge 2 hours before?',
      body: 'One ping before the run so you do not show up in slides. Quiet at night.',
    },
    yes: 'Ping me',
    no: 'Not now',
    working: 'Asking your phone',
  },
  types: {
    'session.new': 'New run',
    'session.nudge': 'Run',
    'session.reminder_24h': 'Run',
    'session.reminder_2h': 'Run',
    'session.waitlist_promoted': 'Waitlist',
    'session.changed': 'Run changed',
    'session.recap': 'Recap',
    'game.up': 'Game',
    'studio.card_ready': 'Card',
    'gamelab.new_game': 'Lab',
    'system.test': 'Test',
  },
});
